import { render } from "./AdminAttribution.vue?vue&type=template&id=0f3226a9"
import script from "./AdminAttribution.vue?vue&type=script&lang=js"
export * from "./AdminAttribution.vue?vue&type=script&lang=js"

import "./AdminAttribution.vue?vue&type=style&index=0&id=0f3226a9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__